<template>
    <b-collapse
        v-if="subGroup"
        :accordion="accordion"
        :id="id"
        :visible="visible"
        class="rkm-sidebar-group-collapse"
    >
        <b-list-group class="rkm-sidebar-group rkm-sidebar-group-normal">
            <slot />
        </b-list-group>
    </b-collapse>

    <b-list-group
        v-else
        class="rkm-sidebar-group rkm-sidebar-group-bold"
    >
        <slot />
    </b-list-group>
</template>

<script>
// Components.
import {BCollapse, BListGroup} from 'bootstrap-vue'

export default {
    components: {BCollapse, BListGroup},
    props: {
        accordion: {type: String},
        id: {type: String},
        subGroup: {type: Boolean},
        visible: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-sidebar-group {
    font-size: 14px;
}
.rkm-sidebar-group-normal {
    font-weight: normal;
}
.rkm-sidebar-group-bold {
    font-size: 14px;
    font-weight: 600;
}
.rkm-sidebar-group-collapse {
    padding-left: 20px;
    padding-right: 20px;
}
</style>